import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_5 = { class: "row align-items-end" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "col-md-4 mb-3" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "col-md-4 mb-3" }
const _hoisted_10 = { class: "col-md-4 mb-3" }
const _hoisted_11 = { class: "col-md-12 mt-2" }
const _hoisted_12 = { class: "row mb-20" }
const _hoisted_13 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_14 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "badge text-bg-warning fs-13"
}
const _hoisted_17 = {
  key: 1,
  class: "badge text-bg-success fs-13"
}
const _hoisted_18 = {
  key: 4,
  class: "dropdown"
}
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 3 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 5 }
const _hoisted_32 = {
  class: "modal fade",
  id: "modal_ShowBe",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_33 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_34 = { class: "modal-content p-15 p-md-40" }
const _hoisted_35 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_36 = {
  class: "modal fade",
  id: "modal_NoramlBe",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_38 = { class: "modal-content p-15 p-md-40" }
const _hoisted_39 = {
  key: 0,
  class: "modal-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_ShowBonDist = _resolveComponent("ShowBonDist")!
  const _component_EditNote = _resolveComponent("EditNote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.auth.can('ADD_BDIS') && _ctx.auth.can('BDIS'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                to: "/add-distribution-notes"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Ajouter un bon de distribution ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [13]
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Zone", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.zone_filter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zone_filter) = $event)),
              options: _ctx.zonesList,
              label: "name",
              placeholder: "Toutes les zones"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Livreur", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.liv_filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.liv_filter) = $event)),
              options: _ctx.LivreursList,
              label: "name",
              placeholder: "Tous les livreurs",
              onSearch: _ctx.onSearchDriver
            }, {
              "no-options": _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode(" Taper un mot pour chercher un livreur ", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "options", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Statut", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.searchStatut) = $event))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("option", { value: "" }, "Statut (Tous)", -1),
              _createElementVNode("option", { value: 0 }, "Brouillon", -1),
              _createElementVNode("option", { value: 1 }, "Enregistré", -1)
            ]), 512), [
              [_vModelSelect, _ctx.filters.searchStatut]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[20] || (_cache[20] = _createElementVNode("label", null, "Créé par", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.filters.searchUser,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.searchUser) = $event)),
              options: _ctx.UsersList,
              label: "name",
              reduce: (u) => u.id,
              placeholder: "Tous les utilisateurs",
              onSearch: _ctx.onSearchUsers
            }, {
              "no-options": _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode(" Taper un mot pour chercher un utilisateur ", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "options", "reduce", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "Recherche", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Chercher...",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event)),
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-primary me-2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, " Filtrer "),
            _createElementVNode("button", {
              class: "btn btn-outline-danger",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, " Annuler ")
          ])
        ]),
        _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "mb-4" }, null, -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.filters.per_page,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRecords()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control shadow-none text-black rounded-0",
              placeholder: "Chercher",
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter())),
              onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [23]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(props.row.note_ref), 1))
              : (props.column.field === 'zone_name')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("b", null, _toDisplayString(props.row.zone_name), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.note_agency), 1)
                  ], 64))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (props.row.created_at != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)) + " ", 1),
                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(props.row.note_by_name), 1)
                    ], 64))
                  : (props.column.field === 'note_save')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.note_save == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Brouillon "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, " Enregistré "))
                      ], 64))
                    : (props.column.field === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[32] || (_cache[32] = _createElementVNode("button", {
                            class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_19, [
                            (props.row.note_parcels_num == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                  (_ctx.auth.can('BDIS'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "dropdown-item d-flex align-items-center",
                                        onClick: ($event: any) => (_ctx.showModalNormal(props.row))
                                      }, _cache[26] || (_cache[26] = [
                                        _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Détails ", -1)
                                      ]), 8, _hoisted_21))
                                    : _createCommentVNode("", true)
                                ]))
                              : (props.row.note_parcels_num != 0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                    (_ctx.auth.can('BDIS'))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.showModal(props.row))
                                        }, _cache[27] || (_cache[27] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]), 8, _hoisted_23))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                            (
                    props.row.note_save == 0 && props.row.note_parcels_num == 0
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                  (_ctx.auth.can('BDIS'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "dropdown-item d-flex align-items-center",
                                        onClick: ($event: any) => (_ctx.removeNote(props.row))
                                      }, _cache[28] || (_cache[28] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Supprimer ", -1)
                                      ]), 8, _hoisted_25))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    props.row.note_save == 0 && props.row.note_parcels_num != 0
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                  (_ctx.auth.can('BDIS') && _ctx.auth.can('SAVE_BDIS'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "dropdown-item d-flex align-items-center",
                                        onClick: ($event: any) => (_ctx.saveBon(props.row))
                                      }, _cache[29] || (_cache[29] = [
                                        _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Reçu ", -1)
                                      ]), 8, _hoisted_27))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (props.row.note_save == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                  (_ctx.auth.can('BDIS'))
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "dropdown-item d-flex align-items-center",
                                        to: {
                      name: 'AddColisDistrPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }
                                      }, {
                                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                                          _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [30]
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (props.row.note_parcels_num != 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.getPDF(props.row))
                                  }, _cache[31] || (_cache[31] = [
                                    _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" PDF ", -1)
                                  ]), 8, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_ShowBonDist, {
                  rowBE: _ctx.rowRef,
                  getRecords: _ctx.getRecords,
                  isOpen: _ctx.isOpen
                }, null, 8, ["rowBE", "getRecords", "isOpen"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_EditNote, {
                  rowBE: _ctx.rowRef,
                  getRecords: _ctx.getRecords,
                  isOpen: _ctx.isOpen
                }, null, 8, ["rowBE", "getRecords", "isOpen"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}